import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
    CmpsButtonModule,
    CmpsContainerModule,
    CmpsIconModule,
    CmpsScrollbarModule,
} from '@cmps/ng-uikit';

import { CmpsLazyI18nModule } from '../../i18n/i18n.module';

import { AdminTableEditorComponent } from './table-editor.component';
import { TranslationIdMap } from './table-editor.i18n';

@NgModule({
    declarations: [AdminTableEditorComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsContainerModule,
        CmpsButtonModule,
        CmpsIconModule,
        CmpsScrollbarModule,
    ],
})
export class CmpsAdminTableEditor {}
